module.exports = __webpack_public_path__ + "b4ca30e668b363e1d0eb3eba47d083d9.MP3";